module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/kv_sp-d43c448a99c2828d79e46861b316f0bd.png";